import {JsonProperty} from 'json-typescript-mapper';
import { Marketdate } from './';
import { Contact } from './';

export enum CommentType {
    None= <any>'None',
    Info= <any>'Info',
    Warning= <any>'Warning',
    Problem= <any>'Problem',
    Success= <any>'Success'

};

export class MarketdateComment {
  @JsonProperty('id')
  public id?: number;

  @JsonProperty('comment')
  public comment?: string;

  @JsonProperty('commentType')
  public commentType?: CommentType;

  @JsonProperty('updated')
  public updated?: any;

  @JsonProperty('created')
  public created?: any;

  @JsonProperty({clazz: Marketdate, name: 'marketdate'})
  public marketdate?: Marketdate;

  @JsonProperty({clazz: Contact, name: 'updatedBy'})
  public updatedBy?: Contact;

  constructor() {
    this.id = void 0;
    this.comment = void 0;
    this.commentType = void 0;
    this.updated = void 0;
    this.created = void 0;
    this.marketdate = void 0;
    this.updatedBy = void 0;
  }
}



// WEBPACK FOOTER //
// ./src/app/entities/marketdate-comment.model.ts